import { render } from "./Header.partial.vue?vue&type=template&id=ebb00180&scoped=true"
import script from "./Header.partial.vue?vue&type=script&lang=js"
export * from "./Header.partial.vue?vue&type=script&lang=js"

import "./Header.partial.vue?vue&type=style&index=0&id=ebb00180&scoped=true&lang=css"

import exportComponent from "/Users/christianreyes/Documents/Proyectos/buzon/buzon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb00180"]])

export default __exports__